import { Box, Button, IconButton, styled, Typography, useTheme } from '@mui/material';
import { X } from 'lucide-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useMobileAppBanner } from 'hooks/use-mobile-app-banner';

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(3, 4),
  backgroundColor: theme.palette.darkBlue.main,
  color: theme.palette.common.white,
}));

const TextContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
});

const MobileAppBanner: React.FC = () => {
  const intl = useIntl();
  const theme = useTheme();
  const { isVisible, storeUrl, dismiss } = useMobileAppBanner();

  if (!isVisible) return null;

  return (
    <Root>
      <TextContainer>
        <Typography variant="subtitle2">
          <FormattedMessage id="MobileAppBanner.title" />
        </Typography>
        <Typography variant="caption">
          <FormattedMessage id="MobileAppBanner.description" />
        </Typography>
      </TextContainer>
      <Button variant="contained" color="inherit" href={storeUrl!} target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="general.download" />
      </Button>
      <IconButton
        size="small"
        color="inherit"
        onClick={dismiss}
        aria-label={intl.formatMessage({ id: 'General.Close' })}>
        <X size={18} color={theme.palette.lightBlue.dark} />
      </IconButton>
    </Root>
  );
};

export default MobileAppBanner;
